<div class="py-2 bg-white">
  <ion-list>
    <ion-item
      *ngFor="let item of options"
      class="cursor-pointer"
      (click)="selectItem(item.option)"
    >
      <ion-icon [name]="item.icon" class="mr-2 text-black text-sm"></ion-icon>
      {{ item.title | titlecase }}
    </ion-item>
  </ion-list>
</div>
